import { useEffect } from "react";
import L from "leaflet";
import useLeaflet from "../../hooks/useLeaflet";

/*
 * This component displays the satellite map tilelayer
 */
const Satelite = () => {
  const context = useLeaflet();
  useEffect(() => {
    if (!context) return;

    const map = L.tileLayer(
      "https://www.google.com/maps/vt?lyrs=s@189&gl=cn&x={x}&y={y}&z={z}",
      {
        maxZoom: 18,
      }
    );

    context.map.addLayer(map);

    return () => context.map.removeLayer(map);
  }, [context.map]);

  return null;
};

export default Satelite;
